import { cn } from "@/shared/lib/utils"

interface BadgeProps {
  children: React.ReactNode
  variant?: "default" | "success" | "warning" | "error" | "info" | "primary" | "secondary" | "danger"
  className?: string
}

export function Badge({ children, variant = "default", className }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
        {
          "bg-gray-100 text-gray-800": variant === "default",
          "bg-green-100 text-green-800": variant === "success",
          "bg-yellow-100 text-yellow-800": variant === "warning",
          "bg-red-100 text-red-800": variant === "error" || variant === "danger",
          "bg-blue-100 text-blue-800": variant === "info",
          "bg-emerald-100 text-emerald-800": variant === "primary",
          "bg-slate-100 text-slate-800": variant === "secondary",
        },
        className
      )}
    >
      {children}
    </span>
  )
}
